import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCqSm9v8N55Bnb9GRvnj-Kh64jcurhV_5I",
  authDomain: "plataforma-clientes-f8e63.firebaseapp.com",
  projectId: "plataforma-clientes-f8e63",
  storageBucket: "plataforma-clientes-f8e63.firebasestorage.app",
  messagingSenderId: "781536287557",
  appId: "1:781536287557:web:68ce183ddbd828862dfc2c"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Firebase Functions
export const sendWelcomeEmail = httpsCallable(functions, 'sendWelcomeEmail');